import React, { useState } from "react";
import { Office } from "./OfficesManager";
interface OfficesListProps {
  offices: Office[];
  onEdit: (officeId: string) => void;
  onDelete: (officeId: string) => void;
  onToggleStatus: (officeId: string, currentStatus: boolean) => void;
  onAddOffice: () => void;
}

const OfficesList: React.FC<OfficesListProps> = ({
  offices,
  onEdit,
  onDelete,
  onToggleStatus,
  onAddOffice,
}) => {
  const [statusFilter, setStatusFilter] = useState<string>("all");

  const filteredOffices = offices.filter((office) => {
    if (statusFilter === "all") return true;
    // Assuming status is determined by having availabilities
    const isActive = office.availability && office.availability.length > 0;
    return statusFilter === "active" ? isActive : !isActive;
  });

  const getOfficeCategory = (office: Office): string => {
    // You can customize this logic based on your business rules
    if (office.name.toLowerCase().includes("central")) return "Sede Principal";
    if (office.name.toLowerCase().includes("regional")) return "Regional";
    return "Sucursal";
  };

  const isOfficeActive = (office: Office): boolean => {
    return office.availability && office.availability.length > 0;
  };

  return (
    <div className="offices-list">
      <div className="filters">
        <div className="filter-group">
          <label htmlFor="office-status-filter">Filtrar por Estado</label>
          <select
            id="office-status-filter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">Todos los estados</option>
            <option value="active">Activos</option>
            <option value="inactive">Inactivos</option>
          </select>
        </div>
        <div className="filter-group">
          <label>&nbsp;</label>
          <button className="btn btn--primary" onClick={onAddOffice}>
            Agregar Oficina
          </button>
        </div>
      </div>

      <div className="offices-grid">
        {filteredOffices.map((office) => (
          <div
            key={office.id}
            className="office-card"
            data-category={getOfficeCategory(office)
              .toLowerCase()
              .replace(" ", "-")}
            data-status={isOfficeActive(office) ? "active" : "inactive"}
          >
            <div className="office-card__header">
              <h3 className="office-card__title">{office.name}</h3>
              <span className="office-card__category">
                {getOfficeCategory(office)}
              </span>
            </div>
            <div className="office-card__body">
              <div className="office-card__details">
                <div className="office-card__detail">
                  <i className="fas fa-map-marker-alt office-card__detail-icon icon-primary"></i>
                  <span>
                    {office.address}, {office.city}, {office.state}
                  </span>
                </div>
                <div className="office-card__detail">
                  <i className="fas fa-phone office-card__detail-icon icon-primary"></i>
                  <span>{office.phone}</span>
                </div>
                {office.email && (
                  <div className="office-card__detail">
                    <i className="fas fa-envelope office-card__detail-icon icon-primary"></i>
                    <span>{office.email}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="office-card__footer">
              <div className="office-card__status">
                <span
                  className={`status-badge ${
                    isOfficeActive(office)
                      ? "status-badge--active"
                      : "status-badge--inactive"
                  }`}
                >
                  ● {isOfficeActive(office) ? "Activo" : "Inactivo"}
                </span>
              </div>
              <div className="office-card__actions">
                <button
                  className="btn btn--secondary"
                  onClick={() => onEdit(office.id)}
                >
                  Editar
                </button>
                {isOfficeActive(office) ? (
                  <button
                    className="btn btn--danger"
                    onClick={() => onDelete(office.id)}
                  >
                    Eliminar
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredOffices.length === 0 && (
        <div className="empty-state">
          <div className="empty-state__icon">
            <i className="fas fa-building"></i>
          </div>
          <h3>No se encontraron oficinas</h3>
          <p>No hay oficinas que coincidan con los filtros aplicados.</p>
        </div>
      )}
    </div>
  );
};

export default OfficesList;
